export const gameStates = {
  UNKNOWN: "UNKNOWN",
  WAITING: "WAITING",
  STARTING: "STARTING",
  PLAYING: "PLAYING",
  ENDED: "ENDED"
}